<div class="project-layer">

    <div class="d-flex">
        <div class="align-items-center">
            <mat-icon class="left-mat-icon"
                      *ngIf="hasChilds"
                      (click)="layer.cardExpansed = !layer.cardExpansed">
                {{layer.cardExpansed ? 'arrow_drop_down' : 'arrow_right'}}</mat-icon>
            <mat-icon class="left-mat-icon no-pointer"
                      *ngIf="!hasChilds"
            ></mat-icon>
        </div>
        <div class="d-flex align-items-center max-width" matTooltip="{{ layer.pretty_name || layer.name }}">
            <mat-checkbox class="ms-1 me-2" [checked]="layer.visible" [value]="layer.id"
                          [disabled]="!layer.enabled" [ngClass]="{'disabled': !layer.enabled}"
                          (change)="changeVisibility($event)" [indeterminate]="layer.visible && someChecked && hasChilds">


            </mat-checkbox>
            <span class="layer-name text-truncate">{{ layer.pretty_name || layer.name }} </span>
            <div class="d-flex">
                <div *ngIf="has2D" class="mode-badge  ms-1" [class.gray]="layer.layer.indexOf('gray') != -1">
                                                <span matTooltip="{{layer.description}}" matTooltipPosition="above"
                                                      matTooltipClass="custom-tooltip">2D</span>
                </div>
                <div *ngIf="has3D" class="mode-badge second-mode-badge ms-1"
                     [class.gray]="layer.layer.indexOf('gray') != -1">
                                                <span matTooltip="{{layer.description}}" matTooltipPosition="above"
                                                      matTooltipClass="custom-tooltip">3D</span>
                </div>
            </div>
        </div>
        <div>
            <button matIconButton [matMenuTriggerFor]="baseLayerMenu" *ngIf="showColorEnhancement || debug">
                <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu class="layer-menu" #baseLayerMenu="matMenu">

                <button [disabled]="!(layer.visible && layer.enabled)  " mat-menu-item *ngIf="showColorEnhancement"
                        (click)="toggleLayerContrast(this.layer)">
                    <mat-icon class="switch-button"
                              [class.on]="layer.enableContrast">{{layer.enableContrast ? 'toggle_on' : 'toggle_off'}}</mat-icon>
                    <span>Disaster Auto Contrast</span>
                </button>
                <button mat-menu-item (click)="fitToBbox(layer.coverageGeom)" [disabled]="!layer.visible"
                        *ngIf="layer.coverageGeom && debug">
                    <span>Fit to coverage</span>
                </button>
            </mat-menu>
        </div>
        <mat-icon class="visible-icon" *ngIf="selectedAOI" [class.right-layer]="this.rightLayer"
                  matTooltip="{{toolTip}}" matTooltipPosition="above"
                  matTooltipClass="custom-tooltip">visibility</mat-icon>
    </div>
    <div *ngIf="hasChilds" [hidden]="!layer.cardExpansed"
         class="child-projects ">
        <div *ngFor="let child of layer.aois | orderBy: ordering">
            <app-project-layer-item *ngIf="child.enabled"
                                    [mode3D]="mode3D" [zoomLevel]="zoomLevel" [layer]="child" [parent]="layer"
                                    [selectedAOIS]="selectedAOIS"
                                    (fitBBoxEvent)="fitToBbox($event)" [ordering]="ordering"
                                    (toggleContrastEvent)="toggleContrastEvent.emit($event)"
                                    (updateCollectionOrderEvent)="updateCollectionOrderEvent.emit($event)"
                                    (changeVisibilityEvent)="changeVisibilityEvent.emit($event)"
                                    (extentParentEvent)="extentParent($event)"></app-project-layer-item>
        </div>

    </div>
</div>
